(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chatgpt-gift-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('belmint-gift-slideshow')) {
    customElements.define('belmint-gift-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify && window.Shopify.designMode);
        this.hovered = false;
        this.editorPaused = false;
        this.toggle = this.querySelector('[data-toggle]');
        this.querySelector('.bm-story__controls').hidden = false;
        this.querySelector('[data-next]').addEventListener('click', () => this.choose(this.index + 1), options);
        this.querySelector('[data-previous]').addEventListener('click', () => this.choose(this.index - 1), options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.choose(i), options));
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
        this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', (event) => { if (!event.target.closest('[data-toggle]')) { this.paused = true; this.sync(); } }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.choose(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) { this.editorPaused = true; this.choose(selected); }
        }, options);
        this.show(0);
        this.sync();
      }
      disconnectedCallback() { clearTimeout(this.timer); if (this.abort) this.abort.abort(); }
      choose(index) { this.paused = true; this.show(index); this.sync(); }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          this.dots[i].setAttribute('aria-current', String(active));
        });
      }
      sync() {
        clearTimeout(this.timer);
        const stopped = this.paused || this.hovered || this.editorPaused || document.hidden;
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.querySelector('[data-symbol]').textContent = this.paused ? '▶' : 'Ⅱ';
        this.querySelector('.bm-story__slides').setAttribute('aria-live', stopped ? 'polite' : 'off');
        if (!stopped) this.timer = setTimeout(() => { this.show(this.index + 1); this.sync(); }, Number(this.dataset.interval) || 4500);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
